"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PlayeBarProps = void 0;

var _vue = require("vue");

var _lodash = _interopRequireDefault(require("lodash"));

var _slider = _interopRequireDefault(require("ant-design-vue/lib/slider"));

require("ant-design-vue/lib/slider/style/index.css");

var playeBarProps = {
  // 总秒数
  seconds: {
    type: Number
  },
  // 当前秒数
  curentSeconds: {
    type: Number
  },
  // 是否可以拖拽进度条
  drag: {
    type: Boolean,
    default: false
  },
  isFinish: {
    type: Boolean,
    default: false
  },
  isShowTips: {
    type: Boolean,
    default: false
  },
  state: {
    type: String,
    default: 'stop'
  },
  dragStartTime: {
    type: undefined || Number,
    default: undefined
  },
  disabled: Boolean
};
exports.PlayeBarProps = playeBarProps;
var PlayeBar = (0, _vue.defineComponent)({
  name: 'PlayeBar',
  components: {
    Slider: _slider.default
  },
  props: playeBarProps,
  emits: ['update:state', 'update:dragStartTime', 'update:isShowTips', 'click'],
  setup: function setup(props, ctx) {
    var state = (0, _vue.ref)(props.state);
    var drag = (0, _vue.computed)(function () {
      return props.drag;
    });
    var isDragging = (0, _vue.ref)(false);
    (0, _vue.watch)(function () {
      return state.value;
    }, function (newVal) {
      ctx.emit('update:state', newVal);
    });
    (0, _vue.watch)(function () {
      return props.state;
    }, function (newVal) {
      state.value = newVal;
    });
    var progressPercent = (0, _vue.ref)(0);
    (0, _vue.watch)(function () {
      return props.curentSeconds;
    }, function (newVal) {
      !isDragging.value && (progressPercent.value = newVal);
    });
    (0, _vue.watch)(function () {
      return progressPercent.value;
    }, function (newVal) {
      if (newVal === props.seconds) {
        state.value = 'stop';
      }
    });
    (0, _vue.watch)(function () {
      return props.isFinish;
    }, function (newVal) {
      newVal && (state.value = 'stop');
      newVal && (progressPercent.value = 0);
    });
    (0, _vue.watch)(function () {
      return props.seconds;
    }, function () {
      if (!props.seconds || props.seconds === Infinity || props.seconds === -Infinity) {
        progressPercent.value = 0;
      }
    });
    var totalMinutes = (0, _vue.computed)(function () {
      var seconds = props.seconds;

      if (!seconds || seconds === Infinity || seconds === -Infinity) {
        return '--:--';
      }

      var prefixZero = function prefixZero(num, n) {
        return (Array(n).join('0') + num).slice(-n);
      };

      var m = parseInt("".concat(seconds / 60), 10);
      var s = parseInt("".concat(seconds % 60), 10);
      return "".concat(prefixZero(m, 2), ":").concat(prefixZero(s, 2));
    });
    var curentMinutes = (0, _vue.computed)(function () {
      var seconds = progressPercent.value;

      if (!seconds) {
        return '00:00';
      }

      var prefixZero = function prefixZero(num, n) {
        return (Array(n).join('0') + num).slice(-n);
      };

      var m = parseInt("".concat(seconds / 60), 10);
      var s = parseInt("".concat(seconds % 60), 10);
      return "".concat(prefixZero(m, 2), ":").concat(prefixZero(s, 2));
    });

    var onPlayClick = _lodash.default.debounce(function () {
      if (props.disabled) {
        return;
      }

      if (state.value === 'stop' || state.value === 'prepare') {
        state.value = 'start';
      } else if (state.value === 'pause') {
        state.value = 'continue';
      } else {
        state.value = 'pause';
      }

      ctx.emit('click', state.value);
    }, 300, {
      leading: true
    });

    var onStopClick = _lodash.default.debounce(function () {
      if (props.disabled) {
        return;
      }

      if (state.value !== 'stop') {
        state.value = 'stop';
        progressPercent.value = 0;
      }

      ctx.emit('click', state.value);
    }, 300, {
      leading: true
    });

    var setSliderDragging = function setSliderDragging(isDrag) {
      if (isDrag && state.value === 'stop') {
        return;
      }

      isDragging.value = isDrag;
    }; // 播放进度


    var changeProgress = function changeProgress(newVal) {
      if (state.value === 'pause') {
        state.value = 'continue';
      }

      ctx.emit('update:dragStartTime', newVal);
      setSliderDragging(false);
    };

    var showPlayBarSliderTips = function showPlayBarSliderTips() {
      if (!drag.value) {
        ctx.emit('update:isShowTips', true);
      }
    };

    return {
      drag: drag,
      curentMinutes: curentMinutes,
      totalMinutes: totalMinutes,
      progressPercent: progressPercent,
      onPlayClick: onPlayClick,
      onStopClick: onStopClick,
      showPlayBarSliderTips: showPlayBarSliderTips,
      changeProgress: changeProgress,
      setSliderDragging: setSliderDragging
    };
  },
  render: function render() {
    var _this = this;

    return (0, _vue.createVNode)("div", {
      "class": "play-bar"
    }, [(0, _vue.createVNode)("div", {
      "class": ['btn', this.state === 'stop' || this.state === 'pause' || this.state === 'prepare' ? 'btn-play' : 'btn-pause', this.disabled ? 'btn-play_disabled' : ''],
      "onClick": this.onPlayClick
    }, null), (0, _vue.createVNode)("div", {
      "class": ['btn btn-stop', this.disabled ? 'btn-stop_disabled' : ''],
      "onClick": this.onStopClick
    }, null), (0, _vue.createVNode)("div", {
      "class": "progress"
    }, [(0, _vue.createVNode)("div", {
      "class": "minutes"
    }, [(0, _vue.createVNode)("span", {
      "class": "left-minutes"
    }, [this.curentMinutes]), (0, _vue.createVNode)("span", {
      "class": "right-minutes"
    }, [this.totalMinutes])]), (0, _vue.createVNode)("div", {
      "class": "slider",
      "onMousedown": this.showPlayBarSliderTips,
      "onTouchstart": this.showPlayBarSliderTips
    }, [(0, _vue.createVNode)(_slider.default, {
      "value": _this.progressPercent,
      "onUpdate:value": function onUpdateValue($event) {
        return _this.progressPercent = $event;
      },
      "min": 0,
      "max": this.seconds || 1,
      "step": this.seconds ? 1 : 0,
      "disabled": !this.drag,
      "tooltipVisible": false,
      "onChange": function onChange() {
        return _this.setSliderDragging(true);
      },
      "onAfterChange": this.changeProgress
    }, null)])])]);
  }
});

PlayeBar.install = function (app) {
  app.component(PlayeBar.name, PlayeBar);
  return app;
};

var _default = PlayeBar;
exports.default = _default;